export const getSorting = (value) => {
    if (value === '') return null
    return value
}